import Vue from 'vue';
import Vuex from 'vuex';
import d2admin from './modules/d2admin';
import business from './modules/business';
import DeliveryNote from './modules/DeliveryNote';
import custom from './modules/custom';
import getters from './getters';
import Portal from './modules/Portal';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    d2admin: d2admin,
    business: business,
    DeliveryNote: DeliveryNote,
    custom: custom,
    Portal: Portal
  },
  getters: getters
});